<template>
	<div class="help-dialog" v-if="showData.show">
		
		<div class="dialog-bg"></div>
		<div class="help-box">

			<div class="task-succ">
				<div class="tit">任务完成</div>
				<div class="jf">获得 +{{showData.data.point}} 积分</div>
				<div class="desc">已完成“<span v-html="showData.data.buttonText"></span>”任务！</div>
			</div>

			<div class="cancel-btn">
				<a href="#" @click="cancelDialog"><img src="../../assets/images/sign/btn_close.png" width="100%" alt=""></a>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		props:['showData'],
		methods: {
			cancelDialog () {
				this.$emit('cancel', 'task')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/components/Task-dialog.vue